import { sBanner, sBannerStep } from '../../shared.min.js';

import { sharedElements } from '../shared-mileage-fuelcost/elements/elements.min.js';

import { PriceStatistics } from '../shared-mileage-fuelcost/shared-functions/price-statistics.min.js';
import { VehicleDetails } from '../shared-mileage-fuelcost/shared-functions/vehicle-details.min.js';
import { AnnualMileageCalculation } from '../shared-mileage-fuelcost/shared-functions/annual-mileage.min.js';
import { ResetCalculator } from '../shared-mileage-fuelcost/shared-functions/reset-calculator.min.js';

import { checkSelectedFuelTypeHelper } from '../shared-mileage-fuelcost/helpers/selected-fuel-helper.min.js';

import {
	vehicleDetailsConfig,
	priceStatisticsConfig,
	mileageCalculationConfig,
	resetCalculatorConfig,
} from '../shared-mileage-fuelcost/config/annual-config.min.js';

const mileageTool = {
	cmsContent: {},
	pageElements: {},
	vehicleDetails: {},
	annualMileageInstance: null,
	bannerInstance: null,
	fuelPrices: {},

	mileageToolContent: {
		footNotes: {
			fuelCost: document.getElementById('mileage-fuelcost-txt'),
			date: document.getElementById('mileage-date-txt'),
		},
	},

	init() {
		// Grab CMS content and page elements once
		this.cmsContent = sharedElements.getCMSContent('mileage');
		this.pageElements = sharedElements.getPageElements('mileage');

		this.setUpContinueButton();

		this.getPriceStatistics();

		this.setUpBanner();

		this.setUpLiveUpdateInputs();

		this.setUpRestartButton();
	},

	setUpBanner: function () {
		sBanner(
			this.pageElements.calc,
			[this.cmsContent.bannerStep1Text, this.cmsContent.bannerStep2Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);
	},

	handleAnnualMileageCalculation: function () {
		//build config after vehicle details are fetched
		const config = mileageCalculationConfig({
			pageElements: mileageTool.pageElements,
			cmsContent: mileageTool.cmsContent,
			vehicleMPG: this.vehicleDetails.vehicleMPG,
		});

		this.annualMileageInstance = new AnnualMileageCalculation(config);
		this.annualMileageInstance.handleMileageCalculation();
	},

	setUpContinueButton: function () {
		const config = vehicleDetailsConfig({
			pageElements: mileageTool.pageElements,
			cmsContent: mileageTool.cmsContent,
			selectedFuelType: checkSelectedFuelTypeHelper(mileageTool.pageElements.fuelTypeRadioGroup),
		});

		const vehicleDetails = new VehicleDetails(config, this.bannerInstance);

		this.pageElements.continueButton.addEventListener('click', async e => {
			e.preventDefault();

			this.vehicleDetails = await vehicleDetails.handleContinuePressed();
			this.handleAnnualMileageCalculation();
			sBannerStep(2);
		});
	},

	getPriceStatistics: async function () {
		const config = priceStatisticsConfig({
			pageElements: mileageTool.pageElements,
			cmsContent: mileageTool.cmsContent,
			selectedFuelType: checkSelectedFuelTypeHelper(mileageTool.pageElements.fuelTypeRadioGroup),
		});

		const priceStatistics = new PriceStatistics(config);
		this.fuelPrices = await priceStatistics.getPriceStatistics();

		this.setFootnotes();
	},

	setFootnotes: function () {
		this.mileageToolContent.footNotes.fuelCost.textContent = this.fuelPrices.price || 'N/A';
		this.mileageToolContent.footNotes.date.textContent = this.fuelPrices.lastUpdated || 'N/A';
	},

	setUpLiveUpdateInputs: function () {
		[this.pageElements.annualMileage, this.pageElements.fuelCostInput].forEach(input => {
			input.addEventListener('input', () => {
				if (this.vehicleDetails.vehicleMPG === 0) return;
				this.annualMileageInstance.handleMileageCalculation();
			});
		});
	},

	setUpRestartButton: function () {
		const resetConfig = resetCalculatorConfig({
			pageElements: mileageTool.pageElements,
		});

		const resetCalculator = new ResetCalculator(resetConfig);
		this.pageElements.restartButton.addEventListener('click', e => {
			e.preventDefault();
			resetCalculator.handleRestartPressed();
		});

		sBannerStep(1);
	},
};

document.addEventListener('DOMContentLoaded', () => mileageTool.init());
